<template>
  <div class="caisse-details">
    <CaisseDetails
      :stats="stats"
      :loading="loadingStats"
      :showTPE="true"
      :showAuthorizedUsers="true"
    />

    <!-- Transactions Table Section -->
    <div class="mt-4">
      <h4>{{ $t("caisse.transactions") }}</h4>
      <CaisseTransactionsTable :caisseId="caisseId" />
    </div>
  </div>
</template>

<script>
import apiClient from "@/services/axios";
import CaisseDetails from "./CaisseDetails.vue";
import CaisseTransactionsTable from "./CaisseInvoicesTable.vue";

export default {
  name: "CaisseGeneralTab",
  components: {
    CaisseDetails,
    CaisseTransactionsTable,
  },
  props: {
    caisseId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loadingStats: false,
      stats: {
        currentBalance: 0,
        todayTransactions: 0,
        dailyAmount: 0,
        transactionsByType: {},
        recentActivity: [],
      },
    };
  },
  created() {
    this.fetchStats();
  },
  methods: {
    async fetchStats() {
      try {
        this.loadingStats = true;
        const res = await apiClient.get(
          `/compV3/caisse/stats/${this.caisseId}`
        );
        this.stats = res.data;
      } catch (error) {
        this.$message.error(this.$t("caisse.erreurChargementStatistiques"));
      } finally {
        this.loadingStats = false;
      }
    },
  },
};
</script>

<style scoped>
.caisse-general {
  padding: 1rem;
}

.mt-4 {
  margin-top: 1.5rem;
}
</style>
